module.exports = __webpack_public_path__ + "img/wuwow_logo.aae88b7f.svg";